import { Action, Reducer } from 'redux';
import { AppThunkAction, AppThunkActionAsync } from './../../';
import { ToxnotServiceClient } from './../../ToxnotServiceClient';
import { InventoriesGetNamesResponse } from '../../Models/Api/InventoriesGetName';
import { BulkReportRequest } from '../../Models/Api/BulkReportRequest';

export interface BulkReportContext {
    regulations: string[]
}

export interface BulkReportState {
    inventoryIds: string[],
    reportType: string,
    context: BulkReportContext | null,
    contextJson: string | null,
    inventoryNames: InventoriesGetNamesResponse[]
}

const initialState: BulkReportState = {
    inventoryIds: [],
    reportType: "",
    context: null,
    contextJson: null,
    inventoryNames: []
}

const BulkReportSetData = "SET_BULK_REPORT_DATA";
interface BulkReportSetData {
    type: typeof BulkReportSetData;
    value: Partial<BulkReportState>
}

type KnownAction = BulkReportSetData;

export const actionCreators = {
    setBulkReportData: (value: Partial<BulkReportState>): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const state = getState().bulkReportState;
        if (!state) {
            return;
        }
        dispatch({
            type: BulkReportSetData,
            value: value
        })
    },
    getBulkReportData: (): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        const state = getState().bulkReportState;
        if (!state) {
            return;
        }
        const dataJson = localStorage.getItem("BulkReportLocal");
        if (dataJson !== null) {
            const data = JSON.parse(dataJson) as BulkReportState;
            const serviceClient = new ToxnotServiceClient();
            const result = await serviceClient.getInventoriesNames(data.inventoryIds);

            if (!result.success || result.data === null) {
                return;
            }

            data.inventoryNames = result.data;

            dispatch({
                type: BulkReportSetData,
                value: data
            });
        }
    },
    generateReports: (): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        const state = getState(); 

        if (!state) {
            return;
        }

        const bulkReportingState = state.bulkReportState;

        if (!bulkReportingState) {
            return;
        }

        const serviceClient = new ToxnotServiceClient();

        const request: BulkReportRequest = {
            inventoryIds: bulkReportingState.inventoryIds,
            reportType: bulkReportingState.reportType,
            contextJson: bulkReportingState.contextJson ?? null
        }

        const apiResult = await serviceClient.initializeBulkReporting(request);

        if (!apiResult.success || apiResult.data === null) {
            state.appServices?.displayApiErrorMessage("Sorry, there was a error accessing the database.")
            return;
        }

        // Redirect To Status Page
        window.location.href = `/Publications/Publications?reportIdToOpen=${apiResult.data}`
    }
}

export const reducer: Reducer<BulkReportState> = (state: BulkReportState | undefined, action: Action): BulkReportState => {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case BulkReportSetData:
            const incomingAction = action as BulkReportSetData;
            return {
                ...state,
                ...incomingAction.value
            }
    }

    return state;
}